<!--
     <MetricEditNumber
       readonly
     />

     Public methods:
       set_value(config)
       get_value() → returns config ↑↑↑

     Events:
       change(new_config)
-->

<template>
  <div class="men-cont">
    <div class="men-row">
      <v-select
        v-model="num_type"
        :items="num_types"
        item-text="text"
        item-value="value"
        :label="$vuetify.lang.translator('indicators.variable_type')"
        outlined
        :disabled="readonly"
        @input="update"
        :class="readonly ? 'qmkey-form-input-readonly' : 'qmkey-form-input required'"
      ></v-select>

      <v-checkbox
        v-model="allow_negative"
        :label="$vuetify.lang.translator('indicators.allow_negative')"
        :disabled="readonly"
        @change="update"
      ></v-checkbox>
    </div>

    <v-text-field
      v-model="num_units"
      :label="$vuetify.lang.translator('labels.units')"
      :placeholder="$vuetify.lang.translator('indicators.units_placeholder')"
      :rules="[rule_required]"
      :readonly="readonly"
      type="text"
      :class="readonly ? 'qmkey-form-input-readonly' : 'qmkey-form-input required'"
      outlined
      dense
      background-color="#f2f2f2"
      :disabled="readonly"
      maxlength="16"
      @input="update"
    />
  </div>
</template>

<style lang="scss">
 @import "@/sass/variables.scss";

 .men-cont {
   width: 100%;
   display: flex;
   flex-direction: column;
   padding: 8px;
 }

 .men-row {
   width: 100%;
   display: flex;
   flex-direction: row;
 }
</style>

<script>
 export default {
   name: 'MetricEditNumber',

   props: [
     'readonly',
     'value'
   ],

   data: () => ({
     allow_negative: false,
     num_type: 'int',
     num_units: null,
   }),

   computed: {
    num_types () {
      return [
       {text: this.$vuetify.lang.translator('indicators.num_types.integer'), value: 'int'},
       {text: this.$vuetify.lang.translator('indicators.num_types.decimal'), value: 'float'},
     ];
    }
   },

   mounted() {
    if (this.value) {
      this.set_value(this.value)
    }
   },

   methods: {
     get_value() {
       return this.serialize();
     },

     set_value(config) {
       this.num_type       = config.number_type || 'int';
       this.allow_negative = !config.only_positive;
       this.num_units      = config.units || '';
     },

     serialize() {
       return {
         'number_type': this.num_type,
         'only_positive': !this.allow_negative,
         'units': this.num_units || '',
       };
     },

     rule_required(value) {
       // TODO: Multilang: Change hardcoded string
       return !!value || this.$vuetify.lang.translator('required_field');
     },

     update() {
      this.$emit('input', this.get_value())
     },
   },
 }
</script>
